import { gql, useQuery } from '@apollo/client';
import { PiezoToolCall } from '../../../../client/piezo/signing/toolCalls';

export interface  ListRootMetricsVars {
  domainIdentifier: string;
  accountId: string;
}

export interface ListRootMetricsData {
  listMetrics: {
    metrics: String[];
  };
}

const GQL_LIST_ROOT_METRICS = gql`
  query getRootCwMetrics($domainIdentifier: String!, $accountId: String!, $piezoArtifacts: JSON) {
    listRootMetrics(domainIdentifier: $domainIdentifier, accountId: $accountId, piezoArtifacts: $piezoArtifacts)
  }
`;

export const useListCwRootMetrics = (vars: ListRootMetricsVars) => {
  const piezoToolCalls: PiezoToolCall[] = [
    {
      key: 'listRootMetrics',
      toolId: 'aes/domain/cw/list-internal-cw-metrics',
      parameters: { domain_identifier: vars.domainIdentifier, account_id: vars.accountId },
    },
  ];

  return useQuery<ListRootMetricsData, Record<string, unknown>>(GQL_LIST_ROOT_METRICS, {
    variables: { ...vars },
    context: { piezoToolCalls },
  });
};
